import LogoPng from '../Assets/logo512.png'
function Logo() {
    return (
        <img src={LogoPng} alt="Company Logo" className="absolute left-[0vh] top-[0vh] h-[150px] max-lg:w-[50vw]  max-lg:z-[0]  max-lg:left-[25vw] max-lg:top-[0vh] max-lg:h-[35vh] max-lg:object-cover"></img>
    );
}
export default Logo